export enum SigmaTileJSONLayers {
  TEST = "TEST"
}
